import { jsx as l } from "react/jsx-runtime";
import { clsx as n } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { forwardRef as m } from "react";
import { useEscapeKey as p } from "../../utils/use-escape-key.js";
import { useScrollLock as _ } from "../../utils/use-scroll-lock.js";
import o from "./roche-dialog.module.scss.js";
import { RocheUIDialogPosition as s } from "./roche-dialog.types.js";
const f = ({ children: a, className: t, slot: e }) => /* @__PURE__ */ l("div", { className: n(o.dialog__panel, t), slot: e, children: a }), N = ({ children: a, className: t, slot: e, noPaddingTop: i, noPaddingBottom: d }) => /* @__PURE__ */ l(
  "div",
  {
    className: n(
      o.dialog__head,
      i && o["dialog__head--no-padding-top"],
      d && o["dialog__head--no-padding-bottom"],
      t
    ),
    slot: e,
    children: a
  }
), h = ({ children: a, className: t, slot: e, noPaddingTop: i, noPaddingBottom: d }) => /* @__PURE__ */ l(
  "div",
  {
    className: n(
      o.dialog__content,
      i && o["dialog__content--no-padding-top"],
      d && o["dialog__content--no-padding-bottom"],
      t
    ),
    slot: e,
    children: a
  }
), R = ({ children: a, className: t, slot: e, noPaddingTop: i, noPaddingBottom: d }) => /* @__PURE__ */ l(
  "div",
  {
    className: n(
      o.dialog__footer,
      i && o["dialog__footer--no-padding-top"],
      d && o["dialog__footer--no-padding-bottom"],
      t
    ),
    slot: e,
    children: a
  }
), b = /* @__PURE__ */ m(
  ({ variant: a, isOpen: t = !1, onCancel: e, enableEscapeKey: i = !1, children: d, ...g }, c) => {
    p(e || (() => {
    }), i), _(t);
    const r = n(
      o.dialog,
      a === s.CENTER && o["dialog--center"],
      a === s.TOP && o["dialog--top"]
    );
    return /* @__PURE__ */ l("dialog", { ref: c, className: r, ...g, children: d });
  }
), P = /* @__PURE__ */ Object.assign(b, { Panel: f, Head: N, Content: h, Footer: R });
export {
  P as RocheUIDialog
};
